module.exports = __webpack_public_path__ + "img/img_cadastro.8a5ae224.png";